<template>
  <v-container id="services" fluid class="pa-0 ma-0">
    <div class="top-section" />

    <v-row justify="center" align="center" class="text-center my-10 pt-10">
      <v-col cols="12">
        <span class="title font-weight-medium grey--text text--lighten-4">Services</span>
        <br /><span class="display-1 font-weight-bold grey--text text--lighten-4">What I do</span>
      </v-col>

      <v-col cols="12" class="ma-0 py-0">
        <v-row justify="center">
          <v-col cols="2" class="ma-0 pa-0">
            <hr class="line-divider" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row justify="center" align="center" class="px-10 mb-10 pb-10" style="min-height: 60vh;">
      <v-col cols="10" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card height="100%" :elevation="hover ? 8 : 8" class="cards" style="border-radius: 20px;">
            <v-container class="py-0">
              <v-row align="center" class="text-center" style="background: linear-gradient(to bottom right, rgba(179,121,247, 0.7), rgba(179,121,247)); border-radius: 20px 20px 0 0; height: 200px;">
                <v-col justify="center" align="center">
                  <v-img max-height="150" contain class="ma-3" :src="require('@/assets/EOS650D.svg')" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-card-title style="word-wrap: break-word; word-break: normal;">PHOTOGRAPHY</v-card-title>

                  <v-card-text>I am specialised in nature photography with a penchant for landscapes. You can see my photos in the portfolio.</v-card-text>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="10" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card height="100%" :elevation="hover ? 8 : 8" class="cards" style="border-radius: 20px;">
            <v-container class="py-0">
              <v-row align="center" class="text-center" style="background: linear-gradient(to bottom right, rgba(79,179,108, 0.7), rgba(79,179,108)); border-radius: 20px 20px 0 0; height: 200px;">
                <v-col justify="center" align="center">
                  <v-img max-height="150" contain class="ma-3" :src="require('@/assets/webdev.svg')" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-card-title style="word-wrap: break-word; word-break: normal;">WEB DEVELOPMENT</v-card-title>

                  <v-card-text>I can develop websites in plain HTML, CSS and JavaScript, and webapps with the use of different frameworks (Vue.js, Vuetify, React).</v-card-text>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="10" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card height="100%" :elevation="hover ? 8 : 8" class="cards" style="border-radius: 20px;">
            <v-container class="py-0">
              <v-row align="center" class="text-center" style="background: linear-gradient(to bottom right, rgba(112, 123, 255, 0.7), rgba(112, 123, 255)); border-radius: 20px 20px 0 0; height: 200px;">
                <v-col justify="center" align="center">
                  <v-img max-height="150" contain class="ma-3" :src="require('@/assets/science_communication.svg')" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-card-title style="word-wrap: break-word; word-break: normal;">SCIENCE COMMUNICATION</v-card-title>

                  <v-card-text>I can create science exhibitions, write articles, design documents, do presentations and make it so the public can understand, whatever it's knowledge level.</v-card-text>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
    <!--<v-row class="my-6">
      <v-col class="text-center">
        <v-btn @click="goTo('#about')" large class="font-weight-bold white--text" text style="background: rgba(179,121,247);">more about me</v-btn>
      </v-col>
    </v-row>-->
  </v-container>
</template>

<script>
export default {
  methods: {
    goTo (anchor) {
      this.$vuetify.goTo(anchor)
    }
  }
}
</script>

<style scoped>
.top-section {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSI1NXB4IiB2aWV3Qm94PSIwIDAgMTI4MCAxNDAiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzFlMjUyOCI+PHBhdGggZD0iTTEyODAgMTQwVjBIMGwxMjgwIDE0MHoiLz48L2c+PC9zdmc+);
  background-size: 100% 55px;
  top: 0;
  height: 55px;
  z-index: 1;
  transform: rotateY(180deg) rotateX(0);
}
.line-divider {
  border-radius: 10px;
  background-image: linear-gradient(160deg,rgba(0, 0, 0, 0) 0%, rgba(250, 250, 250) 88%);
  height: 5px;
  border: 0 none;
}

.cards {
  cursor: default;
}
</style>